import styled from 'styled-components';
import {transparentize} from 'polished';
import {StyledContainer} from 'containers/Container';

export const Wrapper = styled.div`
  position: sticky;
  z-index: 99;
  right: 0;
  bottom: 0;
  left: 0;

  padding: 13px 0;
  margin-top: 40px;
  box-sizing: border-box;
  border-top: 1px solid ${({theme}) => theme.variables.borderColor};
  box-shadow: 0 -15px 10px ${({theme}) => `
    ${transparentize(.9, theme.colors.black)};
  `};
  background: ${({theme}) => theme.variables.accentBackgroundColor};
  text-align: right;
`;

export const Container = styled(StyledContainer)`
  align-items: center;
  justify-content: flex-end;
  display: flex;
  
  & > * {
    margin-left: 8px;
  }
`;
